import React, { useEffect, useState } from 'react';
import { createTask, deleteTask, getTasks, updateTask } from './api';
import { initialDialogState, taskListColumns } from './utils';
// import CommentsDialog from './components/CommentsDialog';
import TimesheetDialog from '../../../../../../components/Dialogs/TimesheetDialog';
import { useParams } from 'react-router-dom';
import EditableTable from '../../../../../../components/Tables/EditableTable';
import { createTimesheet, deleteTimesheet, getTimesheets, updateTimesheet } from './timesheetApi';
// import { createComment, getComments } from './components/CommentsDialog/api';
import CommentsDialog from '../../../../../../components/Dialogs/CommentsDialog';
import { createComment, getComments } from './commentsApi';
// import { getProject } from '../../../api';

const initialData = {
  id: "",
  task: "",
  priority: "",
  startDate: "",
  endDate: "",
  status: "",
  hours: 0,
  progress: 0,
  users: [],
};

const PunchList = () => {
  const { equipId } = useParams();
  const [dialogState, setDialogState] = useState(initialDialogState);
  const [selectedTask, setSelectedTask] = useState();
  // const [projectData, setProjectData] = useState();

  useEffect(() => {
    // const fetchProjectData = async () => {
    //   try {
    //     const res = await getProject(projectId);
    //     setProjectData(res);
    //   } catch (error) {
    //     console.error('Error fetching project data:', error);
    //   }
    // };
    // fetchProjectData();
  }, [equipId]);

  const handleButtonClick = (type, row) => {
    setSelectedTask(row.original);
    if (type === 'comments') {
      setDialogState(prev => ({ ...prev, comments: true }));
    } else if (type === 'attachment') {
      setDialogState(prev => ({ ...prev, attachment: true }));
    } else if (type === 'timesheet') {
      setDialogState(prev => ({ ...prev, timesheet: true }));
    }
  };

  const handleDialogClose = () => {
    setDialogState(initialDialogState);
  };

  return (
    <div>
      <EditableTable
        name="Task"
        displayMode="row"
        columns={taskListColumns({
          // project_members: projectData?.users,
          handleButtonClick,
          currentUser: "currentUser",
        })}
        enableEditing={true}
        enableCreate={true}
        initialData={initialData}
        api={{
          getItems: getTasks,
          createItem: createTask,
          updateItem: updateTask,
          deleteItem: deleteTask,
        }}
        parentId={equipId}
      />
      {selectedTask && (
        <>
          <CommentsDialog
            open={dialogState.comments}
            handleClose={handleDialogClose}
            id={selectedTask?.id}
            api={{
              getComments: getComments,
              createComment: createComment
            }}
          />
          <TimesheetDialog
            open={dialogState.timesheet}
            handleClose={handleDialogClose}
            parentId={selectedTask?.id}
            parentName={selectedTask?.task}
            api={{
              getItems: getTimesheets,
              createItem: createTimesheet,
              updateItem: updateTimesheet,
              deleteItem: deleteTimesheet,
            }}
          />
        </>
      )}
    </div>
  );
};

export default PunchList;
